import {
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '../index'
import {
    styledGrowWrap,
    styledLabel,
} from '../../Form/styles/FormView'
import Button from '../../Button'
import Modal from '../Modal'
import {ModalFooterLeft} from '../ModalView'
import React from 'react'
import Select from 'components/Form/Select'
import {TransferChatModalViewProps} from './types'
import {styled} from '../../../stitches/config'
import {useTranslation} from 'react-i18next'

const StyledTransferChatContent = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flexStart',
})
const StyledLabel = styled('label', styledLabel)
const StyledGrowWrap = styled('div', styledGrowWrap, {width: '400px'})

const TransferChatModalView = ({
    comment,
    isChannelClosed,
    isChannelSuspended,
    onClose,
    onCancel,
    queues,
    selectedQueue,
    setComment,
    setSelectedQueue,
}: TransferChatModalViewProps): React.ReactElement => {
    const {t} = useTranslation()

    const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedQueue(event.target.value)
    }

    const onChangeComment = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
        setComment(event.target.value)
    }

    return (
        <Modal onClose={onCancel}>
            <ModalHeader title={t('Transfer customer')} />
            <ModalContent>
                <StyledTransferChatContent>
                    <StyledLabel htmlFor='selectTransferQueue'>{t('Select transfer queue')}</StyledLabel>
                    <Select id='selectTransferQueue' onChange={onChange} tabIndex={-1} value={selectedQueue}>
                        <option value=''>{t('Select')}</option>
                        {queues.map((queueInfo) => (
                            <option
                                disabled={queueInfo.closed || queueInfo.suspended}
                                key={queueInfo.id}
                                value={queueInfo.id}
                            >{queueInfo.name}
                            </option>
                        ))}
                    </Select>
                </StyledTransferChatContent>
                <StyledLabel htmlFor='transferComment'>{t('Transfer comment (only agents see this)')}</StyledLabel>
                <StyledGrowWrap data-replicated-value={comment}>
                    <textarea
                        id='transferComment'
                        onChange={onChangeComment}
                        placeholder={t('Write an optional comment for agents')}
                        value={comment}
                    />
                </StyledGrowWrap>
            </ModalContent>
            <ModalFooter>
                <ModalFooterLeft>
                    <Button onPress={onCancel} tabIndex={-1} text={t('Cancel')} />
                </ModalFooterLeft>
                <Button color='filled' disabled={isChannelClosed || isChannelSuspended} margin='left' onPress={onClose} tabIndex={-1} text={t('Transfer')} />
            </ModalFooter>
        </Modal>
    )
}

export default TransferChatModalView
